































































import {Vue, Component, Prop} from 'vue-property-decorator';
import AlterationApplications from "@/modules/budget/alteration/form/tabs/AlterationApplications.vue";
import AlterationApplicationsIncome from "@/modules/budget/alteration/form/tabs/AlterationApplicationsIncome.vue";
import AlterationReferencesABP from "@/modules/budget/alteration/form/tabs/AlterationReferencesABP.vue";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";

interface AccessModule {
    modules: string;
    active?: boolean;
    is_in_hierarchy?: boolean;
    position?: string;
    operations?: any[];
}

interface AccessLevels {
    is_in_hierarchy: boolean;
    position?: string;
    operations: any[];
    active: boolean;
}

@Component({
    components: {
        'alteration-references-abp': AlterationReferencesABP,
        'alteration-application-uf': AlterationApplications,
        'alteration-application-income': AlterationApplicationsIncome }
})
export default class ApplForm extends AlterationI18nMixin {
    @Prop({
        required: true,
        default: null
    })
    public requestTypeOptions: any;
    @Prop({
        required: true,
        default: null
    })
    public regionBase: any;
    @Prop({
        required: true,
        default: null
    })
    public yearList: any;
    @Prop({
        required: true,
        default: null
    })
    public userId: any;

    @Prop({
        required: true,
        default: null
    })
    public accessModules: any;
    @Prop({
        required: true,
        default: null
    })
    public applicationsItem: any;

    @Prop({
        required: true,
        default: true,
    })
    public isLoadToJournalEnabled!: boolean;

    private applicationsABP = false;
    private applicationsUO = false;
    private applicationsIncome = false;
    private reLoadChildABP = false;
    private mCodeReferenceInc = '005.002.008';
    private mCodeRequestABP = '005.002.003';
    private mCodeReferenceExp = '005.002.002';
    private accessLevelsRequestABP: AccessLevels = {
        is_in_hierarchy: false,
        position: undefined,
        operations: [],
        active: false
    };

    private accessLevelsReferenceExp: AccessLevels = {
        is_in_hierarchy: false,
        position: undefined,
        operations: [],
        active: false
    };

    private accessLevelsReferenceInc: AccessLevels = {
        is_in_hierarchy: false,
        position: undefined,
        operations: [],
        active: false
    };

    get showRequestABPTab(): boolean {
        return this.accessLevelsRequestABP?.is_in_hierarchy === true;
    }

    get showReferenceExpTab(): boolean {
        return this.accessLevelsReferenceExp?.is_in_hierarchy === true;
    }

    get showReferenceIncTab(): boolean {
        return this.accessLevelsReferenceInc?.is_in_hierarchy === true;
    }

    get isRequestABPReady(): boolean {
        return this.accessLevelsRequestABP !== null && this.regionBase !== null;
    }
    public created() {
        this.$watch('applicationsItem', () => {
            // applicationsItem приходит только из AlterationForm.applsABPActive — открываем «Заявки АБП»
            this.activateTab('requestABPTab');
            if (this.applicationsItem.level === 'abp') {
                this.applicationsABP = this.applicationsItem && this.applicationsItem !== null && this.applicationsItem.requestType !== 'individual';
                // Защита от undefined ref
                this.$nextTick(() => {
                    if (this.$refs.altAllAbp) {
                        // eslint-disable-next-line
                        // @ts-ignore
                        this.$refs.altAllAbp.altAllAbp(this.applicationsItem);
                    }
                });

            }
        });
        this.$watch('accessModules', () => {
            this.$nextTick(() => {
                // ABP
                this.accessLevelsRequestABP = this.accessModules.find((item: AccessModule) => item.modules === this.mCodeRequestABP);

                this.$set(this, 'applicationsABP', this.accessLevelsRequestABP?.active);

                // Expenses
                this.accessLevelsReferenceExp = this.accessModules.find((item: AccessModule) => item.modules === this.mCodeReferenceExp);
                this.$set(this, 'applicationsUO', this.accessLevelsReferenceExp?.active);

                // Income
                this.accessLevelsReferenceInc = this.accessModules.find((item: AccessModule) => item.modules === this.mCodeReferenceInc);

                this.$set(this, 'applicationsIncome', this.accessLevelsReferenceInc?.active);

            });
        });
    }
    public async mounted() {}
    // Активирует вкладку по ref, а не по индексу: индекс в b-tabs зависит от того,
    // какие вкладки доступны пользователю. Если вкладки нет (нет доступа) — ничего не делает
    private activateTab(refName: string) {
        this.$nextTick(() => {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs[refName]?.activate();
        });
    }
    private applicationsABPActive(currentAlteration: {}){
        // eslint-disable-next-line
        // @ts-ignore
        this.applicationsABP = false;
        this.applicationsUO = true;
        // после консолидации — на «Справки (расходы)»
        this.activateTab('referenceExpTab');
        this.$nextTick(() => {
            if (this.$refs.altApplAbp) {
                // eslint-disable-next-line
                // @ts-ignore
                this.$refs.altApplAbp.altApplAbp(currentAlteration);
            }
        });
        this.$emit('reqABPActive', currentAlteration);
    }
    private referencesABPActive(currentAlteration: {}){
        // eslint-disable-next-line
        // @ts-ignore
        if (this.accessLevelsRequestABP.position === 'abp') {
            // eslint-disable-next-line
            // @ts-ignore
            if (currentAlteration.requestType === 'individual') {
                // eslint-disable-next-line
                // @ts-ignore
                this.$emit('refsABPActive', currentAlteration);
                // this.$refs.altRefAbp.altRefAbp(currentAlteration);
                // eslint-disable-next-line
                // @ts-ignore
                this.applicationsABP = false;
            } else {
                // eslint-disable-next-line
                // @ts-ignore
                this.$emit('applsABPActive', currentAlteration);
            }
        }
    }
    private onReload(val: boolean) {
        this.$emit('reLoadC', val);
    }
    private onReloadABP(val: boolean) {
        this.reLoadChildABP = val;
    }
    private unReLoadChildABP(val: boolean) {
        this.reLoadChildABP = val;
    }
}
